import React, { useState } from "react";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import "./ContactForm.css";

const ContactForm = ({ send, setImageUrl, clubData, message }) => {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: "",
    postalCode: "",
    optin: false,
    matchVenue: "", // Ajout du champ pour la question Oui/Non
  });

  const [errors, setErrors] = useState({
    birthDate: false,
  });

  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Limite à partir de laquelle le texte sera tronqué
  const textLimit = 100;
  const text = clubData.optinText;

  // Vérifie si le texte est plus long que la limite
  const isTextLong = text.length > textLimit;
  const displayedText = expanded ? text : `${text.substring(0, textLimit)}...`;

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    if (name === "matchVenue") {
      setErrors({ ...errors, matchVenue: false }); // Reset the error when the user selects an option
    }
    if (name === "birthDate") {
      setErrors({ ...errors, birthDate: false }); // Reset the error on change
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!formData.matchVenue) {
    //   setErrors({ ...errors, matchVenue: true });
    //   return; // Ne pas soumettre le formulaire si la question n'est pas répondue
    // }

    if (formData.birthDate) {
      const age = calculateAge(formData.birthDate);
      if (age < 18) {
        setErrors({ ...errors, birthDate: true });
        return;
      }
    } else {
      setErrors({ ...errors, birthDate: true });
      return;
    }

    handleSendClick();
  };

  const handleSendClick = async () => {
    setButtonDisabled(true);
    await send(formData, message);
    setButtonDisabled(false);
  };

  const handleBackClick = () => {
    setImageUrl(null);
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData({
        ...formData,
        phone: value,
      });
    }
  };

  return (
    <Container maxWidth="sm">
      <div className="title" style={{ color: `${clubData.textColor}` }}>
        {" "}
        Entrez vos informations
      </div>
      <form style={{ color: `${clubData.textColor}` }} onSubmit={handleSubmit}>
        {clubData.firstname && (
          <TextField
            label="Prénom"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}
        {clubData.lastname && (
          <TextField
            label="Nom"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}
        {clubData.email && (
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}
        {clubData.phone && (
          <TextField
            label="Téléphone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handlePhoneChange}
            fullWidth
            margin="dense"
            required
            inputMode="numeric"
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}
        {clubData.birthDate && (
          <TextField
            label="Date de naissance"
            name="birthDate"
            type="date"
            value={formData.birthDate}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            error={errors.birthDate}
            helperText={
              errors.birthDate
                ? "Vous devez être majeur pour soumettre ce formulaire."
                : ""
            }
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              shrink: true,
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}
        {clubData.postalCode && (
          <TextField
            label="Code Postal"
            name="postalCode"
            type="tel"
            value={formData.postalCode}
            onChange={handleChange}
            fullWidth
            margin="dense"
            inputMode="numeric"
            required
            InputProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du texte de l'input
              },
              notchedOutline: {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
              },
            }}
            InputLabelProps={{
              style: {
                color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
              },
            }}
          />
        )}

        {/* Ajout de la question Oui/Non
        <FormControl
          component="fieldset"
          margin="dense"
          required
          error={errors.matchVenue}
        >
          <FormLabel component="legend" style={{ fontSize: "10px" }}>
            SEREZ-VOUS PRÉSENT AU STADE POUR OGC NICE – ASSE ?
          </FormLabel>
          <RadioGroup
            name="matchVenue"
            value={formData.matchVenue}
            onChange={handleChange}
            row
          >
            <FormControlLabel value="oui" control={<Radio />} label="Oui" />
            <FormControlLabel value="non" control={<Radio />} label="Non" />
          </RadioGroup>
          {errors.matchVenue && (
            <FormHelperText>Veuillez répondre à cette question.</FormHelperText>
          )}
        </FormControl> */}

        <FormControlLabel
          control={
            <Checkbox
              name="optin"
              checked={formData.optin}
              onChange={handleChange}
              color="primary"
              sx={{ color: clubData.btnColor }}
            />
          }
          label={
            <>
              <Typography style={{ fontSize: "10px" }}>
                {displayedText}
              </Typography>
              {isTextLong && (
                <span
                  onClick={toggleExpanded}
                  style={{
                    fontSize: "10px",
                    color: clubData.textColor,
                    textDecoration: "underline",
                  }}
                >
                  {expanded ? "Voir moins" : "Voir plus"}
                </span>
              )}
            </>
          }
        />
        <Button
          type="submit"
          variant="contained"
          style={{
            backgroundColor: !buttonDisabled
              ? `${clubData.btnColor}`
              : "#dadada",
            color: `${clubData.textColor}`,
            marginBottom: "1vh",
          }}
          disabled={buttonDisabled}
        >
          {buttonDisabled ? "Chargement..." : "Envoyer"}
        </Button>
      </form>

      <Button
        onClick={handleBackClick}
        variant="outlined"
        style={{
          backgroundColor: "#ffffff00",
          color: `${clubData.btnColor}`,
          borderColor: `${clubData.btnColor}`,
        }}
      >
        Annuler
      </Button>
    </Container>
  );
};

export default ContactForm;
